/* eslint-disable no-undef */
const flassMessage = (icon, title, text) => {
  Swal.fire({
    icon,
    title,
    text,
  });
};

export default flassMessage;
